import { render, staticRenderFns } from "./layoutMain.vue?vue&type=template&id=53d068a4"
import script from "./layoutMain.vue?vue&type=script&lang=js"
export * from "./layoutMain.vue?vue&type=script&lang=js"
import style0 from "./layoutMain.vue?vue&type=style&index=0&id=53d068a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports